import { render, staticRenderFns } from "./DotLoader.vue?vue&type=template&id=5cab5cca&scoped=true"
var script = {}
import style0 from "./DotLoader.vue?vue&type=style&index=0&id=5cab5cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cab5cca",
  null
  
)

export default component.exports